<app-sidebar>
  <div class="multi-search-page">
    <div class="page-nav">
      <button mat-stroked-button type="button" class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ backButtonLabel }}
      </button>
    </div>

    <div class="page-header">
      <div>
        <h1>{{ batchLabel }}</h1>
        <p class="progress">{{ progressLabel }}</p>
      </div>
      <span [matTooltip]="downloadDisabledTooltip">
        <button
          mat-stroked-button
          type="button"
          color="primary"
          class="download-button"
          [disabled]="isLoading || isDownloading || hasActiveRequests"
          [matMenuTriggerFor]="downloadMenu">
          <mat-icon [class.spin-icon]="isDownloading">
            {{ isDownloading ? 'autorenew' : 'download' }}
          </mat-icon>
          Download as
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </span>
      <mat-menu #downloadMenu="matMenu">
        <button mat-menu-item type="button" [disabled]="isDownloading || hasActiveRequests" (click)="downloadBatchPdf()">
          <mat-icon>picture_as_pdf</mat-icon>
          <span>PDF</span>
        </button>
        <button mat-menu-item type="button" [disabled]="isDownloading || hasActiveRequests" (click)="downloadBatchExcel()">
          <mat-icon>table_view</mat-icon>
          <span>Excel</span>
        </button>
      </mat-menu>
    </div>

    <div class="loading-state" *ngIf="isLoading">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading multi search requests...</p>
    </div>

    <div class="empty-state" *ngIf="!isLoading && !hasRequests">
      <mat-icon>event_note</mat-icon>
      <p>No requests in this multi search.</p>
    </div>

    <div class="history-card" *ngIf="!isLoading && hasRequests">
      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let request">{{ getCustomerName(request) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="searchCriteria">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Search Criteria</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <ng-container *ngIf="isIdLookup(request); else nonIdCriteria">
              ID: <span class="masked-id">{{ getMaskedLookupId(request) }}</span>
            </ng-container>
            <ng-template #nonIdCriteria>{{ getSearchCriteria(request) }}</ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <mat-icon [color]="getStatusColor(request.status)">{{ getStatusIcon(request.status) }}</mat-icon>
            {{ formatStatusLabel(request.status) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
          <mat-cell *matCellDef="let request">{{ formatDate(request.createdAt) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="availability">
          <mat-header-cell *matHeaderCellDef>Availability</mat-header-cell>
          <mat-cell *matCellDef="let request" [matTooltip]="getAvailabilityTooltip(request)">
            <span class="availability-chip">
              <mat-icon [color]="getAvailabilityIconColor(request)">{{ getAvailabilityIcon(request) }}</mat-icon>
              {{ getAvailabilityText(request) }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <div class="actions-cell" *ngIf="request.status === 'COMPLETE'">
              <span [matTooltip]="canViewRequest(request) ? 'View data' : getViewDisabledReason(request)">
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="!canViewRequest(request)"
                  (click)="viewData(request)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </span>

              <span [matTooltip]="getMarkDncTooltip(request)">
                <button
                  mat-icon-button
                  type="button"
                  color="warn"
                  [disabled]="!canMarkDnc(request) || isMarkDncLoading(request)"
                  (click)="markAsDnc(request)">
                  <mat-icon [class.spin-icon]="isMarkDncLoading(request)">
                    {{ isMarkDncLoading(request) ? 'autorenew' : 'phone_disabled' }}
                  </mat-icon>
                </button>
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="50"></mat-paginator>
    </div>
  </div>
</app-sidebar>
